function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.1947 80V73.4247L22.5476 71.9635V7.79299L11.3409 6.57534V0H44.9612L65.7192 53.5769L85.2038 0H117.423V6.57534L108.381 7.54946C108.297 12.5013 108.212 17.5342 108.127 22.6484C108.127 27.6814 108.127 32.7144 108.127 37.7473V42.2527C108.127 47.2856 108.127 52.3186 108.127 57.3516C108.212 62.3846 108.297 67.4176 108.381 72.4505L117.805 73.4247V80H77.1807V73.4247L86.4773 72.3288C86.6471 67.377 86.6895 62.5469 86.6046 57.8387C86.6046 53.1304 86.6471 48.7874 86.732 44.8097L86.9867 17.8995L64.3184 80H54.5124L30.1886 17.7778L30.8254 42.1309V71.8417L41.2681 73.4247V80H10.1947Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("line", {
  y1: 40.1622,
  x2: 128,
  y2: 40.1622,
  stroke: "white",
  strokeWidth: 4
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  y1: 56.3784,
  x2: 128,
  y2: 56.3784,
  stroke: "white",
  strokeWidth: 4
});

var SvgLogoLight = function SvgLogoLight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 80,
    viewBox: "0 0 128 80",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoLight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-light.2fba57f8.svg";
export { ForwardRef as ReactComponent };